/* 7 O'CLOCK – Such-Panel (08.10.2026, Verbesserungen 22.10.2026: Schreibweisen, Tippfehler, Umschreibungen, Zuletzt gesucht, Beliebte Suchen, keine Treffer)
   Liquify tauscht beim Tippen den Bereich li-render="predictive-search-target" aus, lädt bei leerem Feld aber nichts.
   Dieses Script merkt sich den Startzustand (Kategorien, Schnellzugriff, Bestseller) und zeigt ihn wieder,
   sobald das Feld geleert wird. Enter im Feld öffnet wie bisher die Suchergebnisseite. */
(function () {
  'use strict';
  function init() {
    var wrap = document.querySelector('.nav_search-wrapper [li-render="predictive-search-wrapper"]');
    if (!wrap) return;
    var input = wrap.querySelector('[li-render="predictive-search-input"]');
    var target = wrap.querySelector('[li-render="predictive-search-target"]');
    if (!input || !target) return;
    var start = target.innerHTML;
    var t;
    input.addEventListener('input', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        if (!input.value.trim()) { target.innerHTML = start; renderRecent(); }
      }, 320); /* nach dem Debounce von Liquify (300ms), damit eine späte Antwort nichts überschreibt */
    });
    /* Seite dahinter nicht mitscrollen lassen, solange die Suche offen ist */
    var root = document.documentElement;
    var lockY = 0;
    function lock() {
      if (root.classList.contains('oc-srch-open')) return;
      lockY = window.pageYOffset || document.documentElement.scrollTop || 0;
      root.style.setProperty('--oc-srch-lock-top', (-lockY) + 'px');
      root.classList.add('oc-srch-open');
    }
    function unlock() {
      if (!root.classList.contains('oc-srch-open')) return;
      root.classList.remove('oc-srch-open');
      root.style.removeProperty('--oc-srch-lock-top');
      window.scrollTo(0, lockY);
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-search="toggle"]')) lock();
      else if (e.target.closest('[fs-modal-element="close-2222"]')) unlock();
    }, true);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') unlock(); });
    /* Formular abgeschickt (Enter / Suchen-Taste) → Sperre lösen, damit die Ergebnisseite normal scrollt */
    var form = input.form;
    if (form) form.addEventListener('submit', function () { root.classList.remove('oc-srch-open'); });
    /* Blinkender Cursor vor „Lieblingsprodukt finden …“, solange das Feld leer und nicht angetippt ist –
       zeigt, dass man hier tippen kann, ohne die Tastatur ungefragt zu öffnen (Alina, 08.10.2026) */
    var holder = input.parentElement;
    var caret = document.createElement('span');
    caret.className = 'oc-srch_caret';
    caret.setAttribute('aria-hidden', 'true');
    holder.appendChild(caret);
    function placeCaret() { caret.style.left = (input.offsetLeft - 3) + 'px'; }
    /* Handy: Fokus ohne Antippen öffnet keine Tastatur und zeigt keinen echten Cursor – dort erst nach dem Antippen ausblenden */
    var touch = window.matchMedia && window.matchMedia('(hover: none)').matches;
    var tapped = false;
    function syncCaret() {
      var focused = document.activeElement === input && (!touch || tapped);
      holder.classList.toggle('is-active', focused || !!input.value);
      placeCaret();
    }
    input.addEventListener('pointerdown', function () { tapped = true; });
    input.addEventListener('focus', syncCaret);
    input.addEventListener('blur', function () { tapped = false; setTimeout(syncCaret, 0); });
    input.addEventListener('input', syncCaret);
    window.addEventListener('resize', placeCaret);
    document.addEventListener('click', function (e) { if (e.target.closest('[data-search="toggle"]')) setTimeout(syncCaret, 60); });
    syncCaret();
    var wrapEl = document.querySelector('.nav_search-wrapper');
    /* iPhone mit offener Tastatur: Panel bleibt in voller Höhe (keine Lücke). Was von Tastatur bzw. Safari-Leiste
       verdeckt wird, kommt als Innenabstand unten dazu, damit sich alles bis zum letzten Produkt scrollen lässt. */
    function setVh() {
      var vv = window.visualViewport;
      if (!wrapEl || !vv) return;
      var kb = Math.max(0, Math.round(window.innerHeight - vv.height - vv.offsetTop));
      wrapEl.style.setProperty('--oc-srch-kb', kb + 'px');
    }
    setVh();
    if (window.visualViewport) {
      window.visualViewport.addEventListener('resize', setVh);
      window.visualViewport.addEventListener('scroll', setVh);
    }
    window.addEventListener('resize', setVh);
    document.addEventListener('click', function (e) { if (e.target.closest('[data-search="toggle"]')) { setVh(); setTimeout(setVh, 400); } });
    /* Treffer verschärft (08.10.2026, Alina): eigener Index aller Produkte (templates/collection.oc-index.liquid),
       gefiltert im Browser. Findet Wortteile und ignoriert Umlaute: „gläser“ → Trinkgläser, Weingläser, Longdrinkgläser …
       Kategorien: alle Navi-Punkte, deren Name das Suchwort enthält, plus Shopifys Kategorie-Vorschläge. */
    var reqId = 0;
    var rootUrl = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    /* Schreibweisen angleichen (22.10.2026): ä/ae → a, ö/oe → o, ü/ue → u, ß → ss, doppelte Buchstaben einfach – „glaeser“, „glässer“ = „gläser“ */
    function norm(x) { return (x || '').toLowerCase().replace(/ä/g, 'a').replace(/ö/g, 'o').replace(/ü/g, 'u').replace(/ß/g, 'ss').replace(/ae/g, 'a').replace(/oe/g, 'o').replace(/ue/g, 'u').replace(/([a-z])\1+/g, '$1'); }
    var idxPromise = null;
    function loadIndex() {
      if (idxPromise) return idxPromise;
      function page(n) {
        return fetch(rootUrl + 'collections/all?view=oc-index&page=' + n, { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.text() : ''; })
          .then(function (h) { var d = document.createElement('div'); d.innerHTML = h; return d.querySelector('.oc-srch_list'); });
      }
      idxPromise = page(1).then(function (ul) {
        if (!ul) return [];
        var total = parseInt(ul.getAttribute('data-oc-total'), 10) || 0;
        var pages = Math.min(6, Math.ceil(total / 250));
        var more = [];
        for (var p = 2; p <= pages; p++) more.push(page(p));
        return Promise.all(more).then(function (rest) {
          var items = [], seen = {};
          [ul].concat(rest).forEach(function (u) {
            if (!u) return;
            Array.prototype.slice.call(u.children).forEach(function (li) {
              var a = li.querySelector('a'); var key = a ? a.getAttribute('href') : '';
              if (seen[key]) return; seen[key] = 1;
              items.push({ el: li, raw: li.getAttribute('data-oc-title') || '', t: norm(li.getAttribute('data-oc-title')), av: li.getAttribute('data-oc-avail') !== '0' });
            });
          });
          return items;
        });
      }).catch(function () { idxPromise = null; return []; });
      return idxPromise;
    }
    var navCats = [];
    try { var cj = target.querySelector('[data-oc-srch-cats]'); if (cj) navCats = JSON.parse(cj.textContent); } catch (x) {}
    function handleOf(u) { var m = String(u || '').match(/\/collections\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : ''; }
    var navHandles = {};
    navCats.forEach(function (c) { var h = handleOf(c.u); if (h) navHandles[h] = 1; });
    function stems(w) {
      if (w.length < 5) return [];
      var out = [];
      [/n$/, /en$/, /e$/, /s$/].forEach(function (re) { var x = w.replace(re, ''); if (x !== w && x.length >= 4 && out.indexOf(x) < 0) out.push(x); });
      return out;
    }
    function wordsOf(term) { return norm(term).split(/\s+/).filter(Boolean); }
    /* Suchbegriffe umschreiben (Theme-Editor › Header › Suche): „sale = letzte chance“ (22.10.2026) */
    var syn = {};
    try {
      var sj = target.querySelector('[data-oc-srch-syn]');
      String(sj ? JSON.parse(sj.textContent) || '' : '').split(/\n/).forEach(function (line) {
        var p = line.split('=');
        if (p.length < 2) return;
        var k = norm(p[0].trim()), v = p.slice(1).join('=').trim();
        if (k && v) syn[k] = v;
      });
    } catch (x) {}
    /* Tippfehler: Wort, das nirgends vorkommt, durch das ähnlichste Wort aus den Produktnamen ersetzen („alska“ → „alaska“) */
    function lev(a, b, max) {
      if (Math.abs(a.length - b.length) > max) return max + 1;
      var prev = [], cur, i, j;
      for (j = 0; j <= b.length; j++) prev[j] = j;
      for (i = 1; i <= a.length; i++) {
        cur = [i]; var best = i;
        for (j = 1; j <= b.length; j++) {
          cur[j] = Math.min(prev[j] + 1, cur[j - 1] + 1, prev[j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
          if (cur[j] < best) best = cur[j];
        }
        if (best > max) return max + 1;
        prev = cur;
      }
      return prev[b.length];
    }
    var tokens = null, tokenShow = {};
    function tokenList(items) {
      if (tokens) return tokens;
      var seen = {};
      tokens = [];
      items.forEach(function (it) {
        it.raw.toLowerCase().split(/[^a-z0-9äöüß]+/).forEach(function (rw) { var k = norm(rw); if (k.length >= 3 && !tokenShow[k]) tokenShow[k] = rw; });
        it.t.split(/[^a-z0-9]+/).forEach(function (w) { if (w.length >= 3 && !seen[w]) { seen[w] = 1; tokens.push(w); } });
      });
      navCats.forEach(function (c) { norm(c.t).split(/[^a-z0-9]+/).forEach(function (w) { if (w.length >= 3 && !seen[w]) { seen[w] = 1; tokens.push(w); } }); });
      return tokens;
    }
    function rewrite(term, items) {
      var n = norm(term), changed = false, words, show = {};
      if (syn[n]) { words = wordsOf(syn[n]); changed = true; syn[n].toLowerCase().split(/\s+/).forEach(function (x) { show[norm(x)] = x; }); }
      else {
        words = wordsOf(term).map(function (w) { if (syn[w]) { changed = true; syn[w].toLowerCase().split(/\s+/).forEach(function (x) { show[norm(x)] = x; }); return norm(syn[w]); } return w; });
        words = [].concat.apply([], words.map(function (w) { return w.split(/\s+/); }));
      }
      var toks = tokenList(items);
      words = words.map(function (w) {
        if (w.length < 4) return w;
        var sts = stems(w);
        var hit = toks.some(function (k) { return k.indexOf(w) > -1 || sts.some(function (x) { return k.indexOf(x) > -1; }); });
        if (hit) return w;
        var max = w.length >= 7 ? 2 : 1, best = null, bd = max + 1;
        toks.forEach(function (k) {
          var cand = k.length > w.length + max ? k.slice(0, w.length + 1) : k;
          var d = lev(w, cand, max);
          if (d < bd || (d === bd && best && k.length < best.length)) { bd = d; best = k; }
        });
        if (best && bd <= max) { changed = true; return best; }
        return w;
      });
      var original = term.toLowerCase().split(/\s+/);
      var label = words.map(function (w, i) { return show[w] || tokenShow[w] || original[i] || w; }).join(' ');
      return { words: words, changed: changed, label: label };
    }
    function hitScore(t, words) {
      var s = 0;
      for (var i = 0; i < words.length; i++) {
        var p = t.indexOf(words[i]);
        /* Mehrzahl/Einzahl: „vasen“ findet auch „Keramikvase“, „tassen“ auch „Tasse“ */
        if (p < 0) { var sts = stems(words[i]); for (var si = 0; si < sts.length && p < 0; si++) p = t.indexOf(sts[si]); }
        if (p < 0) return -1;
        /* Zubehör nach hinten: „Untersetzer für Gläser“ ist kein Glas */
        if (t.indexOf('fur ' + words[i]) > -1 && t.replace('fur ' + words[i], '').indexOf(words[i]) < 0) s += 2;
      }
      return s;
    }
    function chipArrow() { return '<svg viewBox="0 0 12 12" aria-hidden="true"><path d="M4.5 2.5 8 6l-3.5 3.5" fill="none" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>'; }
    function esc(x) { var d = document.createElement('div'); d.textContent = x; return d.innerHTML; }
    function blockWith(label, inner) {
      var b = document.createElement('div'); b.className = 'oc-srch_block';
      b.innerHTML = '<div class="oc-srch_label">' + label + '</div>';
      b.appendChild(inner); return b;
    }
    function findBlock(box, label) {
      var ls = box.querySelectorAll('.oc-srch_label');
      for (var i = 0; i < ls.length; i++) if (ls[i].textContent.trim() === label) return ls[i].parentElement;
      return null;
    }
    /* Keine Treffer: Hinweis, Kategorien und Bestseller statt leerer Fläche (22.10.2026) */
    var startBox = document.createElement('div'); startBox.innerHTML = start;
    function showEmpty(box, term) {
      if (box.querySelector('.oc-srch_best')) return;
      if (!box.querySelector('.oc-srch_empty')) {
        Array.prototype.slice.call(box.children).forEach(function (n) { if (!n.classList.contains('oc-srch_hint')) n.remove(); });
        var b = document.createElement('div'); b.className = 'oc-srch_block';
        b.innerHTML = '<p class="oc-srch_empty">Zu „' + esc(term) + '“ haben wir gerade nichts gefunden. Vielleicht gefällt dir das hier:</p>';
        box.appendChild(b);
        var cats = startBox.querySelector('.oc-srch_block.is-band');
        if (cats) box.appendChild(cats.cloneNode(true));
      }
      var best = startBox.querySelector('[data-oc-srch-best]');
      if (best) { var c = best.cloneNode(true); c.classList.add('oc-srch_best'); box.appendChild(c); }
    }
    /* Zuletzt gesucht (pro Besucher, im Browser gespeichert) */
    var RKEY = 'oc_srch_recent';
    function getRecent() { try { return JSON.parse(localStorage.getItem(RKEY) || '[]') || []; } catch (x) { return []; } }
    function saveRecent(term) {
      term = (term || '').trim(); if (term.length < 2) return;
      var list = getRecent().filter(function (x) { return norm(x) !== norm(term); });
      list.unshift(term);
      try { localStorage.setItem(RKEY, JSON.stringify(list.slice(0, 5))); } catch (x) {}
    }
    function renderRecent() {
      var blk = target.querySelector('[data-oc-srch-recent]');
      if (!blk) return;
      var list = getRecent(), box = blk.querySelector('.oc-srch_chips');
      box.innerHTML = '';
      list.forEach(function (x) { var a = document.createElement('a'); a.className = 'oc-srch_chip'; a.href = rootUrl + 'search?q=' + encodeURIComponent(x); a.setAttribute('data-oc-srch-term', x); a.textContent = x; box.appendChild(a); });
      blk.hidden = !list.length;
    }
    renderRecent();
    /* Chip „Beliebte Suchen“ / „Zuletzt gesucht“ antippen → Begriff direkt im Panel suchen */
    target.addEventListener('click', function (e) {
      var chip = e.target.closest('[data-oc-srch-term]');
      if (chip) {
        e.preventDefault();
        input.value = chip.getAttribute('data-oc-srch-term');
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new KeyboardEvent('keyup', { bubbles: true }));
        saveRecent(input.value);
        syncCaret();
        return;
      }
      if (e.target.closest('a') && input.value.trim()) saveRecent(input.value);
    });
    if (input.form) input.form.addEventListener('submit', function () { saveRecent(input.value); });
    function applyResults() {
      var term = input.value.trim();
      if (!term) return;
      var my = ++reqId;
      loadIndex().then(function (items) {
        if (my !== reqId || input.value.trim() !== term) return;
        var box = target.querySelector('.oc-srch.is-results');
        if (!box) return;
        var rw = rewrite(term, items), words = rw.words;
        /* Shopify-Produktblock ohne sichtbare Produkte (alles ausgeblendet) entfernen */
        var spb = findBlock(box, 'Produkte'); if (spb && !spb.querySelector('.oc-srch_item')) spb.remove();
        /* Kategorien */
        var have = {}, chips = document.createElement('div'); chips.className = 'oc-srch_chips';
        var haveT = {};
        navCats.forEach(function (c) {
          if (hitScore(norm(c.t), words) < 0 || have[c.u] || haveT[norm(c.t)]) return;
          have[c.u] = 1; haveT[norm(c.t)] = 1;
          var a = document.createElement('a'); a.className = 'oc-srch_chip is-coll'; a.href = c.u; a.innerHTML = esc(c.t) + chipArrow();
          chips.appendChild(a);
        });
        var catBlock = findBlock(box, 'Kategorien');
        /* Shopify-Vorschläge nur übernehmen, wenn die Kollektion in der Navi steht (Alina, 08.10.2026) */
        if (catBlock) Array.prototype.slice.call(catBlock.querySelectorAll('.oc-srch_chip')).forEach(function (a) {
          var u = a.getAttribute('href'), tt = norm(a.textContent.trim());
          if (!navHandles[handleOf(u)]) return;
          if (have[u] || haveT[tt]) return; have[u] = 1; haveT[tt] = 1; chips.appendChild(a);
        });
        if (catBlock && !chips.children.length) { catBlock.remove(); catBlock = null; }
        /* exakte Kategorie (z. B. „vasen“) nach vorne */
        var wq = words.join(' ');
        Array.prototype.slice.call(chips.children).forEach(function (a) { if (norm(a.textContent.trim()) === wq) chips.insertBefore(a, chips.firstChild); });
        /* Produkte */
        var hits = [];
        items.forEach(function (it, i) { var sc = hitScore(it.t, words); if (sc >= 0) hits.push({ it: it, sc: sc, i: i }); });
        /* ausverkaufte Produkte nach hinten */
        hits.sort(function (x, y) { return (x.it.av ? 0 : 1) - (y.it.av ? 0 : 1) || x.sc - y.sc || x.i - y.i; });
        var list = null;
        if (hits.length) {
          list = document.createElement('ul'); list.className = 'oc-srch_list'; list.setAttribute('role', 'list');
          hits.slice(0, 80).forEach(function (h) { list.appendChild(h.it.el.cloneNode(true)); });
        }
        if (rw.changed) {
          /* Shopifys Treffer passen zum falsch geschriebenen Wort nicht – raus */
          var sq = findBlock(box, 'Vorschläge'); if (sq) sq.remove();
          var sp = findBlock(box, 'Produkte'); if (sp && !list) sp.remove();
          var hint = document.createElement('p'); hint.className = 'oc-srch_hint';
          hint.innerHTML = 'Ergebnisse für „' + esc(rw.label) + '“';
          if (!box.querySelector('.oc-srch_hint')) box.insertBefore(hint, box.firstChild);
        }
        if (!chips.children.length && !list) {
          if (!findBlock(box, 'Produkte')) showEmpty(box, term);
          return;
        }
        /* Leerer Zustand („nichts gefunden“) wird ersetzt */
        var empty = box.querySelector('.oc-srch_empty');
        if (empty) { Array.prototype.slice.call(box.children).forEach(function (n) { if (!n.classList.contains('oc-srch_hint')) n.remove(); }); }
        var foot = box.querySelector('.oc-srch_footer');
        if (!foot) {
          foot = document.createElement('div'); foot.className = 'oc-srch_footer';
          foot.innerHTML = '<a class="oc-srch_all" href="' + rootUrl + 'search?q=' + encodeURIComponent(term) + '&options%5Bprefix%5D=last">Alle Ergebnisse für „' + esc(term) + '“</a>';
          box.appendChild(foot);
        }
        var prodBlock = findBlock(box, 'Produkte');
        var pagesBlock = findBlock(box, 'Seiten');
        var anchor = prodBlock || pagesBlock || foot;
        if (chips.children.length) {
          if (catBlock) catBlock.replaceChild(chips, catBlock.querySelector('.oc-srch_chips'));
          else box.insertBefore(blockWith('Kategorien', chips), anchor);
        }
        if (list) {
          if (prodBlock) prodBlock.replaceChild(list, prodBlock.querySelector('.oc-srch_list'));
          else box.insertBefore(blockWith('Produkte', list), pagesBlock || foot);
        }
        /* Button unten passend zum umgeschriebenen Begriff (z. B. „sale“ → Letzte Chance) */
        if (rw.changed) {
          var allA = foot.querySelector('.oc-srch_all');
          var firstChip = chips.querySelector('a');
          if (allA && !list && firstChip) { allA.href = firstChip.getAttribute('href'); allA.textContent = 'Zu „' + firstChip.textContent.trim() + '“'; }
          else if (allA) { allA.href = rootUrl + 'search?q=' + encodeURIComponent(rw.label) + '&options%5Bprefix%5D=last'; allA.textContent = 'Alle Ergebnisse für „' + rw.label + '“'; }
        }
      });
    }
    document.addEventListener('liquify:predictive-search-rendered', applyResults);
    /* Jedes Öffnen = neue Suche: Feld leeren, Startansicht (Kategorien + Bestseller) zeigen, nach oben (Alina, 08.10.2026) */
    document.addEventListener('click', function (e) {
      if (!e.target.closest('[data-search="toggle"]')) return;
      reqId++;
      clearTimeout(t);
      loadIndex();
      input.value = '';
      target.innerHTML = start;
      renderRecent();
      var sc = document.getElementById('predictive-search');
      if (sc) sc.scrollTop = 0;
      syncCaret();
    }, true);
    input.setAttribute('autocomplete', 'off');
    input.setAttribute('enterkeyhint', 'search');

    /* Lupe angetippt → sofort tippen können, ohne nochmal ins Feld zu klicken (Alina, 02.11.2026).
       iPhone öffnet die Tastatur nur, wenn der Fokus direkt im Antippen gesetzt wird – das Panel ist da aber noch
       unsichtbar. Darum bekommt im selben Moment ein unsichtbares Hilfsfeld den Fokus (Tastatur geht auf),
       sobald das Panel sichtbar ist, wandert der Fokus ins echte Suchfeld. */
    var proxy = document.createElement('input');
    proxy.type = 'text';
    proxy.setAttribute('aria-hidden', 'true');
    proxy.setAttribute('tabindex', '-1');
    proxy.setAttribute('autocomplete', 'off');
    proxy.style.cssText = 'position:fixed;top:0;left:0;width:1px;height:1px;opacity:0;border:0;padding:0;font-size:16px;pointer-events:none;z-index:-1;';
    document.body.appendChild(proxy);
    var focusTimer = null;
    function focusInput() {
      clearInterval(focusTimer);
      tapped = true; /* echter Cursor statt des gezeichneten */
      try { proxy.focus({ preventScroll: true }); } catch (x) { proxy.focus(); }
      var tries = 0;
      focusTimer = setInterval(function () {
        tries++;
        if (input.offsetParent !== null || input.getClientRects().length) {
          try { input.focus({ preventScroll: true }); } catch (x) { input.focus(); }
        }
        if (document.activeElement === input || tries > 40) {
          clearInterval(focusTimer);
          if (document.activeElement !== input && document.activeElement === proxy) proxy.blur();
          syncCaret();
        }
      }, 25);
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-search="toggle"]') && !e.target.closest('.nav_search-wrapper [fs-modal-element]')) focusInput();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
